import React from 'react';
import {SvgIcon, SvgIconProps} from '@mui/material';

const hibobPath = 'M10.8505 10.9017C10.9915 10.5929 11.0634 10.2528 11.0646 9.89017C11.0646 9.88695 11.0646 9.88403 11.0646 9.88081C11.0646 9.48602 10.9777 9.11989 10.8063 8.79265C10.6338 8.46336 10.3843 8.14431 10.0646 7.93434L10.0599 7.93112C10.0266 7.90919 9.97042 7.87643 9.97042 7.8428C9.97042 7.80917 10.0254 7.77349 10.0485 7.75273C10.5057 7.34215 10.7402 6.71165 10.7402 6.05483C10.7402 5.69834 10.6697 5.36379 10.5308 5.06053C10.3983 4.77131 10.2064 4.51601 9.96047 4.30165C9.46852 3.87264 8.78967 3.63635 8.04911 3.63635H4.95964C4.94619 3.63635 4.93536 3.64717 4.93536 3.66062V12.3394C4.93536 12.3528 4.94619 12.3636 4.95964 12.3636H8.30883C9.06811 12.3636 9.76334 12.1212 10.267 11.6808C10.5185 11.4609 10.7151 11.1988 10.8505 10.9017ZM6.49896 5.20851C6.49896 5.19652 6.50862 5.18657 6.5209 5.18657H8.21261C8.65689 5.18657 9.00962 5.44158 9.13304 5.85217C9.22576 6.16011 9.1696 6.48705 8.97861 6.74908C8.78441 7.01608 8.4735 7.17546 8.14738 7.17546H6.52617C6.51417 7.17546 6.50423 7.16581 6.50423 7.15352L6.49896 5.20851ZM6.49896 8.7482C6.49896 8.73533 6.50949 8.72509 6.52295 8.72509H8.36733C8.85168 8.72509 9.23629 8.99297 9.37083 9.42402C9.47203 9.74746 9.41061 10.0908 9.20265 10.366C8.9909 10.6464 8.65191 10.8137 8.29626 10.8137H6.52851C6.51534 10.8137 6.50452 10.8035 6.50452 10.7909L6.49896 8.7482Z';

export default function HibobIcon({colored=false, ...props}: {
    colored?: boolean;
} & SvgIconProps) {
    return (
        <SvgIcon {...props} viewBox="0 0 16 16">
            {!colored && (
                <defs>
                    <mask id="hibobIconMask">
                        <rect width="16" height="16" fill="white"/>
                        <path d={hibobPath} fill="black"/>
                    </mask>
                </defs>
            )}
            <rect
                width="16"
                height="16"
                rx="2.28571"
                fill={colored ? '#E52C51' : 'currentColor'}
                mask={!colored ? 'url(#hibobIconMask)' : undefined}
            />
            {colored && (
                <path d={hibobPath} fill="#fff"/>
            )}
        </SvgIcon>
    );
}
